import { useContext, useState } from 'react';
import { Card, Container, CardHeader, Typography, Button, CardContent, Grid, CircularProgress } from '@material-ui/core';
import { LockOpenOutlined as UnLockIcon } from '@material-ui/icons';
import { authContext } from 'helpers/services';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import { TextField } from 'formik-material-ui';


let ForgotPassword = () => {
    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(false);

    let forgotPasswordSchema = yup.object().shape({
        email: yup.string().default('').required("Email is mandatory"),
    })


    return (
        <Container maxWidth="sm">
            <Card elevation={0}>
                <CardHeader
                    disableTypography
                    title={<Typography variant="h4">Forgot your password?</Typography>}
                />

                <CardContent style={{ padding: 0 }}>
                    <Grid container>
                        <Grid item xs>
                            <Formik
                                initialValues={forgotPasswordSchema.getDefault()}
                                validationSchema={forgotPasswordSchema}
                                onSubmit={async (values, action) => {
                                    setLoading(true);
                                    let res = await authService.forgotPassword(values.email);
                                    if (res === false)
                                        setLoading(false);
                                }}
                            >
                                <Form>
                                    <Grid container alignItems="center">
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                name="email"
                                                label="Email"
                                                variant="outlined"
                                                fullWidth
                                                type="email"
                                            />
                                        </Grid>
                                        <Grid item xs>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="secondary"
                                                disabled={isLoading}
                                                startIcon={isLoading ? <CircularProgress size={20} /> : <UnLockIcon />}
                                            >
                                                Send code
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </Formik>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Container>
    )
}

export default ForgotPassword;